import { Observable, of } from 'rxjs';
import { IAccessTokenResponse } from '../../common/models/token.model';
import { Injectable } from '@angular/core';
import { map, catchError, finalize, mergeMap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { StartupService } from '../../common/services/startup.service';
import { constants } from './../../configs/config-internal-constants';
import { session } from '../../common/session/session';
import { applicationContentConfig } from './../../configs/config-internal-content';

@Injectable({
  providedIn: 'root',
})
export class HttpAuthService {
  private httpAuthOptions = undefined;
  private httpHeaders = undefined;

  constructor(
    private httpClient: HttpClient,
    private startupService: StartupService
  ) {}

  public httpApiCall(requestUrl: string): Observable<any> {
    return this.getAccessToken().pipe(
      mergeMap((authInfo: IAccessTokenResponse) => {
        let requestFunction = new Observable<ArrayBuffer>();
        requestFunction = this.httpClient.get(
          this.replaceUrlParams(requestUrl, authInfo),
          authInfo.headers
        );
        return requestFunction.pipe(
          map((responseData: any) => {
            return responseData;
          }),
          catchError((error: Error) => {
            throw error;
          }),
          finalize(() => {
            this.revokeAccessToken(authInfo.accessToken).subscribe();
          })
        );
      })
    );
  }

  replaceUrlParams(requestUrl: string, authInfo: IAccessTokenResponse) {
    let reqUrl = requestUrl;
    reqUrl = reqUrl.replace('{{channel}}', constants.CHANNEL);
    reqUrl = reqUrl.replace('{{uid}}', authInfo.uid);
    return reqUrl;
  }

  public getAccessToken() {
    const clientId = this.startupService.apiClientId;
    const headerJson = {
      'x-ibm-client-id': clientId,
      'X-API-VERSION': constants.XAPIVERSION,
      scopes: constants.SCOPE,
      'operationType': constants.V10
    };

    const httpOptions = {
      headers: new HttpHeaders(headerJson),
      withCredentials: true,
    };

    const authorizeUrl =
      this.startupService.host + this.startupService.authorizeEndpoint;
    return this.httpClient.get(authorizeUrl, httpOptions).pipe(
      map((result: IAccessTokenResponse) => {
        if (result && result.accessToken) {
          this.httpHeaders = new HttpHeaders({
            'x-ibm-client-id': this.startupService.apiClientId,
            Authorization: `Bearer ${result.accessToken}`,
            'X-API-VERSION': constants.XAPIVERSION,
            scopes: constants.SCOPE,
            'Content-Type': 'application/json',
            Accept: 'application/json',
            conversationId: session.conversationId,
            'x-platform': session.brand,
          });

          // ready headers
          this.httpAuthOptions = {
            headers: this.httpHeaders,
            withCredentials: true,
          };

          // add access token to session
          session.accessToken = result.accessToken;

          // return access token
          return {
            accessToken: result.accessToken,
            uid: result.uid,
            headers: this.httpAuthOptions,
          } as IAccessTokenResponse;
        } else {
          // Redirect if no access token
          this.errorRedirection();
        }
      }),
      catchError((error: Error) => {
       this.errorRedirection();
        throw error;
      })
    );
  }

  public revokeAccessToken(accessToken: string): Observable<any> {
    const headerJson = {
      'X-API-VERSION': constants.XAPIVERSION,
      Authorization: `Bearer ${accessToken}`,
      'operationType': constants.V10
    };

    const httpOptions = {
      headers: new HttpHeaders(headerJson),
      withCredentials: true,
    };

    return this.httpClient.post(
      this.startupService.host + this.startupService.revokeEndpoint,
      null,
      httpOptions
    );
  }

  errorRedirection() {
    const url = decodeURIComponent(applicationContentConfig.bksErrorPage);
    this.startupService.navigateByUrl(url);
  }
}
